module.exports = __webpack_public_path__ + "static/media/error.d12d156e.svg";